import * as React from 'react'

import { spacing, Strong } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import { SchoolPage_school_upcomingGatherings } from '../gql'
import { i18nKeyPrefix } from '../i18n'
import UpcomingGatheringListing from './UpcomingGatheringListing'

import { Container, StyledText } from './UpcomingGatherings.styles'

const PRE = `${i18nKeyPrefix}-UPCOMING-GATHERINGS`

interface IProps {
  schoolId: number
  upcomingGatherings: SchoolPage_school_upcomingGatherings[]
}

export default function UpcomingGatherings(props: IProps) {
  const { schoolId, upcomingGatherings } = props
  const totalNumberOfGatherings = upcomingGatherings.length

  const [displayedGatheringsCount, setDisplayedGatheringsCount] = React.useState<number>(3)

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const displayedGatherings = upcomingGatherings.slice(0, displayedGatheringsCount)

  return (
    <Container>
      <Strong style={{ marginBottom: `${spacing.majorScale(1)}px` }}>{t(`${PRE}-TITLE`)}</Strong>

      {displayedGatherings.map((gathering, i) => (
        <UpcomingGatheringListing key={i} schoolId={schoolId} upcomingGathering={gathering} />
      ))}

      {displayedGatherings.length < totalNumberOfGatherings ? (
        <StyledText
          data-pendo="upcomingGatheringsViewMoreButton"
          onClick={() => setDisplayedGatheringsCount(displayedGatheringsCount + 5)}
        >
          {t(`${PRE}-MORE`)}
        </StyledText>
      ) : null}
    </Container>
  )
}
